import { I18n } from '../helpers/i18n';

export const MVP_SESSION_TYPES = [
  'Hands-on Desk',
  'Face Close-up',
  'Upper Body',
  'Full Body',
  'Digital Skills',
];

/** i18n keys for session type labels (value stays exact match for backend + Dify KB). */
export const MVP_SESSION_TYPE_I18N_KEYS = {
  'Hands-on Desk': 'session_type_hands_on_desk',
  'Face Close-up': 'session_type_face_close_up',
  'Upper Body': 'session_type_upper_body',
  'Full Body': 'session_type_full_body_moving',
  'Digital Skills': 'session_type_digital_skills',
};

/** Translated label — read at call time so it follows the current UI language. */
export function getMvpSessionTypeLabel(value) {
  const key = MVP_SESSION_TYPE_I18N_KEYS[value];
  return key ? I18n.t(key) : value;
}

export function getMvpSessionTypeOptions() {
  return MVP_SESSION_TYPES.map((value) => ({
    value,
    label: getMvpSessionTypeLabel(value),
  }));
}
